module.exports = __webpack_public_path__ + "media/components/profile/static/icon-arrow-left-35ce015b7fc39d7af8bd349067551e09.svg";